export const CURRENT_PREISMODELL = '2025-03';
